import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { RequestOptionsArgs, Headers} from '@angular/http';
import { AuthService } from './auth.service';

@Injectable()
export class ScoresService {

  constructor(private http: HttpService, private authService: AuthService) { }

  getScores(): Observable<any> {
    let apiUrl = `/assets/data/scores.json`;

    return this.http.get(apiUrl, this.getAuthorizationHeader()).retry(2)
      .map((response: Response) => {
        if (!response || !response.json())
          return null;

        return response.json();
      });
  }

  private getAuthorizationHeader(): RequestOptionsArgs {
    let headers = new Headers();
    headers.append('Authorization', this.authService.getTokenHeaderText());
    return { headers };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/scores.service.ts